import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Breadcrumbs,
  IconButton,
  Link,
  LinkProps,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  Popover,
  Skeleton,
  Toolbar,
} from '@mui/material';
import { useRequest } from 'ahooks';
import NOTIFICATION_API from 'api/notification';
import { CusIconButton } from 'components/CusIconButton';
import { useDrawerContext } from 'context/DrawerContext';
import useResponsive from 'hook/useResponsive';
import { NotificationBing } from 'iconsax-react';
import React from 'react';
import { HiMenuAlt4 } from 'react-icons/hi';
import { Link as RouterLink, useLocation } from 'react-router-dom';

function LinkRouter(props: { to: string; replace?: boolean } & LinkProps) {
  return <Link {...props} component={RouterLink as any} />;
}

export default function Navbar() {
  /* Context */
  const {
    collapse,
    setCollapse,
    setOpenDrawer,
    openDrawer,
    totalNotification,
  } = useDrawerContext();

  // State
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  /* Hooks */
  const { isMdDown, isSmDown } = useResponsive();
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // api
  const listNoti = useRequest(NOTIFICATION_API.today, {
    manual: false,
    ready: open,
  });
  // methods
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position='sticky'
      sx={{
        borderRadius: 0,
        zIndex: (theme) => theme.zIndex.drawer - 1,
        boxShadow: (theme) => theme.shadows[1],
        background: (theme) => theme.palette.common.white,
      }}
    >
      <Toolbar>
        <CusIconButton
          onClick={() => {
            setOpenDrawer(!openDrawer);
            isMdDown ? setCollapse(collapse) : setCollapse(!collapse);
          }}
          sx={{
            color: (theme) => theme.palette.primary.main,
          }}
        >
          <HiMenuAlt4 />
        </CusIconButton>
        <Breadcrumbs
          maxItems={isSmDown ? 2 : 3}
          aria-label='breadcrumb'
          sx={{ px: 2, whiteSpace: 'nowrap' }}
        >
          <LinkRouter underline='hover' color='inherit' to={'/'}>
            Home
          </LinkRouter>
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            return (
              <LinkRouter
                underline='hover'
                color='inherit'
                to={to}
                replace={true}
                key={index}
                textTransform='capitalize'
              >
                {value.replaceAll('-', ' ')}
              </LinkRouter>
            );
          })}
        </Breadcrumbs>
        <Box sx={{ flexGrow: 1 }} />
        <Badge badgeContent={totalNotification?.total || 0} color='primary'>
          <IconButton color='primary' onClick={handleClick}>
            <NotificationBing size='24' variant='Bold' />
          </IconButton>
        </Badge>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          elevation={1}
          slotProps={{
            paper: {
              sx: {
                minHeight: 200,
                maxHeight: 300,
                minWidth: 300,
              },
            },
          }}
        >
          <List
            subheader={
              <ListSubheader
                id='nested-list-subheader'
                sx={{
                  bgcolor: 'common.white',
                }}
              >
                Notifications
              </ListSubheader>
            }
          >
            {listNoti.loading ? (
              Array(4)
                .fill('')
                .map((_, i) => (
                  <ListItem key={i}>
                    <Skeleton
                      variant='text'
                      sx={{ fontSize: '1rem', width: '100%' }}
                    />
                  </ListItem>
                ))
            ) : listNoti.error ? (
              <ListItem>
                <ListItemText primary={listNoti.error.message} />
              </ListItem>
            ) : listNoti.data && listNoti.data.length > 0 ? (
              listNoti.data.map((item, i) => (
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>{item.customer.customerName}</Avatar>
                  </ListItemAvatar>
                  <ListItemText primary='Event 1' secondary='Event 1' />
                </ListItem>
              ))
            ) : (
              <ListItem>
                <ListItemText
                  primary='No data'
                  primaryTypographyProps={{
                    textAlign: 'center',
                  }}
                />
              </ListItem>
            )}
          </List>
        </Popover>
      </Toolbar>
    </AppBar>
  );
}
